<div
  class="flex w-full min-w-0 items-end justify-start gap-1 text-sm"
  [attr.data-id]="message().id"
  [attr.data-index]="index()"
  [ngClass]="{ 'flex-row-reverse': isMyMessage() }"
>
  <div
    class="flex max-w-[60%] flex-col gap-2 rounded-xl p-2 pb-0.5 shadow-xl transition-opacity"
    [ngClass]="{
      'bg-blue-primary text-white': isMyMessage() && !isPendingMessage() && !isFailedMessage(),
      'bg-white text-black': !isMyMessage(),
      'bg-blue-200 text-blue-800 opacity-70': isMyMessage() && isPendingMessage(),
      'bg-red-100 text-red-800 border-red-300 border': isMyMessage() && isFailedMessage(),
    }"
  >
    <div class="flex items-center justify-between text-xs">
      <span class="underline">{{ message().senderName }}</span>
      @if (appointmentCreationAvailable()) {
        <button
          class="flex !h-5 !w-5 items-center justify-center rounded-full bg-gray-4 shadow-sm hover:bg-gray-3"
          [matMenuTriggerFor]="messageActionsMenu"
        >
          <mat-icon
            class="pt-0.5 text-sm"
            [fontIcon]="'more_vert'"
          ></mat-icon>
        </button>
        <mat-menu #messageActionsMenu="matMenu">
          <button
            mat-menu-item
            class="flex items-center justify-center"
            (click)="navigateToPrescriptionsTab(message().metadata['prescriptionId'])"
          >
            {{ "Переглянути в бічній панелі" }}
          </button>
          <button
            mat-menu-item
            class="flex items-center justify-center"
            (click)="navigateToPrescriptionsPage(message().metadata['prescriptionId'])"
          >
            {{ "Переглянути в гарантаціях" }}
          </button>
          <button
            mat-menu-item
            class="flex items-center justify-center"
            (click)="openCreateManualAppointmentModal()"
          >
            {{ "Записати на візит" }}
          </button>
        </mat-menu>
      }
    </div>

    @if (!!message().content) {
      <div class="min-w-0 break-words">
        <div
          class="whitespace-break-spaces break-words"
          [innerHTML]="messageContentWithLinks()"
        ></div>
      </div>
    }

    <div class="min-w-0 break-words">
      @for (file of getFiles(); track file) {
        <div
          (click)="downloadFile(file)"
          class="flex cursor-pointer items-center gap-2"
          [ngClass]="isMyMessage() ? 'hover:text-gray-3' : 'hover:text-blue-primary'"
        >
          <div class="text-xl">
            <mat-icon>file_open</mat-icon>
          </div>
          <div class="text-md pb-1">{{ file }}</div>
        </div>
      }
    </div>
  </div>

  <span class="flex flex-col items-end gap-1 text-xs">
    @if (isMyMessage()) {
      @switch (getState()) {
        @case (MessageState.Sent) {
          <span>
            <mat-icon
              class="text-sm"
              [fontIcon]="'done'"
            ></mat-icon>
          </span>
        }
        @case (MessageState.Read) {
          <span [title]="getUserReadReceipt().readTime | date: 'd MMM HH:mm'">
            <mat-icon
              class="text-sm"
              [fontIcon]="'done_all'"
            ></mat-icon>
          </span>
        }
        @case (MessageState.Pending) {
          <span
            class="flex items-center gap-1"
            title="Надсилається..."
          >
            <shared-spin-loading [size]="12"></shared-spin-loading>
          </span>
        }
        @case (MessageState.Failed) {
          <button
            class="hover:bg-red-200 flex items-center gap-1 rounded px-1 py-0.5 text-xs"
            title="Не вдалося надіслати. Натисніть, щоб повторити"
            (click)="onRetryMessage()"
          >
            <mat-icon class="text-red-600 text-sm">error</mat-icon>
            <span class="text-red-600">повторити</span>
          </button>
        }
      }
    }

    @if (isUpdated()) {
      {{ message().updatedAt | date: "d MMM HH:mm" : "" : "uk" }} (редаговано)
    } @else {
      {{ message().createdAt | date: "d MMM HH:mm" : "" : "uk" }}
    }
  </span>
</div>
